import { FlowConsumerContextEnergy } from '../../context';
import { BuildingType, BuildingAgeType } from '../types';

const usageEstimates: FlowConsumerContextEnergy[] = [
  {
    residents: 1,
    buildingType: BuildingType.Apartment,
    buildingAge: BuildingAgeType.Before1945,
    usageWarmth: 18,
    usageWater: 28,
    usageElectricityLow: 690,
    usageElectricityHigh: 1140,
    usageGas: 810,
  },
  {
    residents: 1,
    buildingType: BuildingType.Apartment,
    buildingAge: BuildingAgeType.Between1945And2000,
    usageWarmth: 18,
    usageWater: 28,
    usageElectricityLow: 730,
    usageElectricityHigh: 960,
    usageGas: 510,
  },
  {
    residents: 1,
    buildingType: BuildingType.Apartment,
    buildingAge: BuildingAgeType.After2000,
    usageWarmth: 18,
    usageWater: 28,
    usageElectricityLow: 870,
    usageElectricityHigh: 1010,
    usageGas: 550,
  },
  {
    residents: 1,
    buildingType: BuildingType.CornerHouse,
    buildingAge: BuildingAgeType.Before1945,
    usageWarmth: 37,
    usageWater: 28,
    usageElectricityLow: 960,
    usageElectricityHigh: 1280,
    usageGas: 1080,
  },
  {
    residents: 1,
    buildingType: BuildingType.CornerHouse,
    buildingAge: BuildingAgeType.Between1945And2000,
    usageWarmth: 37,
    usageWater: 28,
    usageElectricityLow: 950,
    usageElectricityHigh: 1110,
    usageGas: 920,
  },
  {
    residents: 1,
    buildingType: BuildingType.CornerHouse,
    buildingAge: BuildingAgeType.After2000,
    usageWarmth: 37,
    usageWater: 28,
    usageElectricityLow: 1300,
    usageElectricityHigh: 1300,
    usageGas: 710,
  },
  {
    residents: 1,
    buildingType: BuildingType.TerracedHouse,
    buildingAge: BuildingAgeType.Before1945,
    usageWarmth: 26,
    usageWater: 28,
    usageElectricityLow: 840,
    usageElectricityHigh: 1170,
    usageGas: 980,
  },
  {
    residents: 1,
    buildingType: BuildingType.TerracedHouse,
    buildingAge: BuildingAgeType.Between1945And2000,
    usageWarmth: 26,
    usageWater: 28,
    usageElectricityLow: 950,
    usageElectricityHigh: 1110,
    usageGas: 880,
  },
  {
    residents: 1,
    buildingType: BuildingType.TerracedHouse,
    buildingAge: BuildingAgeType.After2000,
    usageWarmth: 26,
    usageWater: 28,
    usageElectricityLow: 1210,
    usageElectricityHigh: 1270,
    usageGas: 710,
  },
  {
    residents: 1,
    buildingType: BuildingType.SemiDetachedHouse,
    buildingAge: BuildingAgeType.Before1945,
    usageWarmth: 33,
    usageWater: 28,
    usageElectricityLow: 1210,
    usageElectricityHigh: 1540,
    usageGas: 1270,
  },
  {
    residents: 1,
    buildingType: BuildingType.SemiDetachedHouse,
    buildingAge: BuildingAgeType.Between1945And2000,
    usageWarmth: 33,
    usageWater: 28,
    usageElectricityLow: 1210,
    usageElectricityHigh: 1290,
    usageGas: 1080,
  },
  {
    residents: 1,
    buildingType: BuildingType.SemiDetachedHouse,
    buildingAge: BuildingAgeType.After2000,
    usageWarmth: 33,
    usageWater: 28,
    usageElectricityLow: 1640,
    usageElectricityHigh: 1550,
    usageGas: 850,
  },
  {
    residents: 1,
    buildingType: BuildingType.DetachedHouse,
    buildingAge: BuildingAgeType.Before1945,
    usageWarmth: 49,
    usageWater: 28,
    usageElectricityLow: 1480,
    usageElectricityHigh: 1820,
    usageGas: 1460,
  },
  {
    residents: 1,
    buildingType: BuildingType.DetachedHouse,
    buildingAge: BuildingAgeType.Between1945And2000,
    usageWarmth: 49,
    usageWater: 28,
    usageElectricityLow: 1560,
    usageElectricityHigh: 1650,
    usageGas: 1360,
  },
  {
    residents: 1,
    buildingType: BuildingType.DetachedHouse,
    buildingAge: BuildingAgeType.After2000,
    usageWarmth: 49,
    usageWater: 28,
    usageElectricityLow: 2090,
    usageElectricityHigh: 1820,
    usageGas: 970,
  },
  {
    residents: 2,
    buildingType: BuildingType.Apartment,
    buildingAge: BuildingAgeType.Before1945,
    usageWarmth: 18,
    usageWater: 28,
    usageElectricityLow: 830,
    usageElectricityHigh: 1270,
    usageGas: 960,
  },
  {
    residents: 2,
    buildingType: BuildingType.Apartment,
    buildingAge: BuildingAgeType.Between1945And2000,
    usageWarmth: 18,
    usageWater: 28,
    usageElectricityLow: 830,
    usageElectricityHigh: 1080,
    usageGas: 540,
  },
  {
    residents: 2,
    buildingType: BuildingType.Apartment,
    buildingAge: BuildingAgeType.After2000,
    usageWarmth: 18,
    usageWater: 28,
    usageElectricityLow: 930,
    usageElectricityHigh: 1100,
    usageGas: 600,
  },
  {
    residents: 2,
    buildingType: BuildingType.CornerHouse,
    buildingAge: BuildingAgeType.Before1945,
    usageWarmth: 37,
    usageWater: 28,
    usageElectricityLow: 1120,
    usageElectricityHigh: 1400,
    usageGas: 1200,
  },
  {
    residents: 2,
    buildingType: BuildingType.CornerHouse,
    buildingAge: BuildingAgeType.Between1945And2000,
    usageWarmth: 37,
    usageWater: 28,
    usageElectricityLow: 1080,
    usageElectricityHigh: 1230,
    usageGas: 950,
  },
  {
    residents: 2,
    buildingType: BuildingType.CornerHouse,
    buildingAge: BuildingAgeType.After2000,
    usageWarmth: 37,
    usageWater: 28,
    usageElectricityLow: 1410,
    usageElectricityHigh: 1390,
    usageGas: 770,
  },
  {
    residents: 2,
    buildingType: BuildingType.TerracedHouse,
    buildingAge: BuildingAgeType.Before1945,
    usageWarmth: 26,
    usageWater: 28,
    usageElectricityLow: 1000,
    usageElectricityHigh: 1340,
    usageGas: 1020,
  },
  {
    residents: 2,
    buildingType: BuildingType.TerracedHouse,
    buildingAge: BuildingAgeType.Between1945And2000,
    usageWarmth: 26,
    usageWater: 28,
    usageElectricityLow: 1060,
    usageElectricityHigh: 1220,
    usageGas: 900,
  },
  {
    residents: 2,
    buildingType: BuildingType.TerracedHouse,
    buildingAge: BuildingAgeType.After2000,
    usageWarmth: 26,
    usageWater: 28,
    usageElectricityLow: 1390,
    usageElectricityHigh: 1370,
    usageGas: 740,
  },
  {
    residents: 2,
    buildingType: BuildingType.SemiDetachedHouse,
    buildingAge: BuildingAgeType.Before1945,
    usageWarmth: 33,
    usageWater: 28,
    usageElectricityLow: 1330,
    usageElectricityHigh: 1590,
    usageGas: 1330,
  },
  {
    residents: 2,
    buildingType: BuildingType.SemiDetachedHouse,
    buildingAge: BuildingAgeType.Between1945And2000,
    usageWarmth: 33,
    usageWater: 28,
    usageElectricityLow: 1370,
    usageElectricityHigh: 1420,
    usageGas: 1100,
  },
  {
    residents: 2,
    buildingType: BuildingType.SemiDetachedHouse,
    buildingAge: BuildingAgeType.After2000,
    usageWarmth: 33,
    usageWater: 28,
    usageElectricityLow: 1730,
    usageElectricityHigh: 1550,
    usageGas: 910,
  },
  {
    residents: 2,
    buildingType: BuildingType.DetachedHouse,
    buildingAge: BuildingAgeType.Before1945,
    usageWarmth: 49,
    usageWater: 28,
    usageElectricityLow: 1690,
    usageElectricityHigh: 1950,
    usageGas: 1500,
  },
  {
    residents: 2,
    buildingType: BuildingType.DetachedHouse,
    buildingAge: BuildingAgeType.Between1945And2000,
    usageWarmth: 49,
    usageWater: 28,
    usageElectricityLow: 1840,
    usageElectricityHigh: 1850,
    usageGas: 1400,
  },
  {
    residents: 2,
    buildingType: BuildingType.DetachedHouse,
    buildingAge: BuildingAgeType.After2000,
    usageWarmth: 49,
    usageWater: 28,
    usageElectricityLow: 2240,
    usageElectricityHigh: 1950,
    usageGas: 1050,
  },
  {
    residents: 3,
    buildingType: BuildingType.Apartment,
    buildingAge: BuildingAgeType.Before1945,
    usageWarmth: 18,
    usageWater: 28,
    usageElectricityLow: 890,
    usageElectricityHigh: 1430,
    usageGas: 990,
  },
  {
    residents: 3,
    buildingType: BuildingType.Apartment,
    buildingAge: BuildingAgeType.Between1945And2000,
    usageWarmth: 18,
    usageWater: 28,
    usageElectricityLow: 880,
    usageElectricityHigh: 1180,
    usageGas: 570,
  },
  {
    residents: 3,
    buildingType: BuildingType.Apartment,
    buildingAge: BuildingAgeType.After2000,
    usageWarmth: 18,
    usageWater: 28,
    usageElectricityLow: 1000,
    usageElectricityHigh: 1150,
    usageGas: 600,
  },
  {
    residents: 3,
    buildingType: BuildingType.CornerHouse,
    buildingAge: BuildingAgeType.Before1945,
    usageWarmth: 37,
    usageWater: 28,
    usageElectricityLow: 1210,
    usageElectricityHigh: 1560,
    usageGas: 1200,
  },
  {
    residents: 3,
    buildingType: BuildingType.CornerHouse,
    buildingAge: BuildingAgeType.Between1945And2000,
    usageWarmth: 37,
    usageWater: 28,
    usageElectricityLow: 1210,
    usageElectricityHigh: 1360,
    usageGas: 980,
  },
  {
    residents: 3,
    buildingType: BuildingType.CornerHouse,
    buildingAge: BuildingAgeType.After2000,
    usageWarmth: 37,
    usageWater: 28,
    usageElectricityLow: 1460,
    usageElectricityHigh: 1510,
    usageGas: 830,
  },
  {
    residents: 3,
    buildingType: BuildingType.TerracedHouse,
    buildingAge: BuildingAgeType.Before1945,
    usageWarmth: 26,
    usageWater: 28,
    usageElectricityLow: 1080,
    usageElectricityHigh: 1420,
    usageGas: 1070,
  },
  {
    residents: 3,
    buildingType: BuildingType.TerracedHouse,
    buildingAge: BuildingAgeType.Between1945And2000,
    usageWarmth: 26,
    usageWater: 28,
    usageElectricityLow: 1200,
    usageElectricityHigh: 1370,
    usageGas: 910,
  },
  {
    residents: 3,
    buildingType: BuildingType.TerracedHouse,
    buildingAge: BuildingAgeType.After2000,
    usageWarmth: 26,
    usageWater: 28,
    usageElectricityLow: 1440,
    usageElectricityHigh: 1500,
    usageGas: 810,
  },
  {
    residents: 3,
    buildingType: BuildingType.SemiDetachedHouse,
    buildingAge: BuildingAgeType.Before1945,
    usageWarmth: 33,
    usageWater: 28,
    usageElectricityLow: 1420,
    usageElectricityHigh: 1710,
    usageGas: 1350,
  },
  {
    residents: 3,
    buildingType: BuildingType.SemiDetachedHouse,
    buildingAge: BuildingAgeType.Between1945And2000,
    usageWarmth: 33,
    usageWater: 28,
    usageElectricityLow: 1520,
    usageElectricityHigh: 1530,
    usageGas: 1110,
  },
  {
    residents: 3,
    buildingType: BuildingType.SemiDetachedHouse,
    buildingAge: BuildingAgeType.After2000,
    usageWarmth: 33,
    usageWater: 28,
    usageElectricityLow: 1830,
    usageElectricityHigh: 1700,
    usageGas: 980,
  },
  {
    residents: 3,
    buildingType: BuildingType.DetachedHouse,
    buildingAge: BuildingAgeType.Before1945,
    usageWarmth: 49,
    usageWater: 28,
    usageElectricityLow: 1730,
    usageElectricityHigh: 2020,
    usageGas: 1520,
  },
  {
    residents: 3,
    buildingType: BuildingType.DetachedHouse,
    buildingAge: BuildingAgeType.Between1945And2000,
    usageWarmth: 49,
    usageWater: 28,
    usageElectricityLow: 1960,
    usageElectricityHigh: 1940,
    usageGas: 1420,
  },
  {
    residents: 3,
    buildingType: BuildingType.DetachedHouse,
    buildingAge: BuildingAgeType.After2000,
    usageWarmth: 49,
    usageWater: 28,
    usageElectricityLow: 2370,
    usageElectricityHigh: 2080,
    usageGas: 1150,
  },
  {
    residents: 4,
    buildingType: BuildingType.Apartment,
    buildingAge: BuildingAgeType.Before1945,
    usageWarmth: 18,
    usageWater: 28,
    usageElectricityLow: 890,
    usageElectricityHigh: 1430,
    usageGas: 1050,
  },
  {
    residents: 4,
    buildingType: BuildingType.Apartment,
    buildingAge: BuildingAgeType.Between1945And2000,
    usageWarmth: 18,
    usageWater: 28,
    usageElectricityLow: 940,
    usageElectricityHigh: 1250,
    usageGas: 600,
  },
  {
    residents: 4,
    buildingType: BuildingType.Apartment,
    buildingAge: BuildingAgeType.After2000,
    usageWarmth: 18,
    usageWater: 28,
    usageElectricityLow: 1000,
    usageElectricityHigh: 1150,
    usageGas: 610,
  },
  {
    residents: 4,
    buildingType: BuildingType.CornerHouse,
    buildingAge: BuildingAgeType.Before1945,
    usageWarmth: 37,
    usageWater: 28,
    usageElectricityLow: 1360,
    usageElectricityHigh: 1630,
    usageGas: 1290,
  },
  {
    residents: 4,
    buildingType: BuildingType.CornerHouse,
    buildingAge: BuildingAgeType.Between1945And2000,
    usageWarmth: 37,
    usageWater: 28,
    usageElectricityLow: 1290,
    usageElectricityHigh: 1410,
    usageGas: 980,
  },
  {
    residents: 4,
    buildingType: BuildingType.CornerHouse,
    buildingAge: BuildingAgeType.After2000,
    usageWarmth: 37,
    usageWater: 28,
    usageElectricityLow: 1580,
    usageElectricityHigh: 1580,
    usageGas: 890,
  },
  {
    residents: 4,
    buildingType: BuildingType.TerracedHouse,
    buildingAge: BuildingAgeType.Before1945,
    usageWarmth: 26,
    usageWater: 28,
    usageElectricityLow: 1150,
    usageElectricityHigh: 1510,
    usageGas: 1140,
  },
  {
    residents: 4,
    buildingType: BuildingType.TerracedHouse,
    buildingAge: BuildingAgeType.Between1945And2000,
    usageWarmth: 26,
    usageWater: 28,
    usageElectricityLow: 1270,
    usageElectricityHigh: 1410,
    usageGas: 910,
  },
  {
    residents: 4,
    buildingType: BuildingType.TerracedHouse,
    buildingAge: BuildingAgeType.After2000,
    usageWarmth: 26,
    usageWater: 28,
    usageElectricityLow: 1510,
    usageElectricityHigh: 1590,
    usageGas: 860,
  },
  {
    residents: 4,
    buildingType: BuildingType.SemiDetachedHouse,
    buildingAge: BuildingAgeType.Before1945,
    usageWarmth: 33,
    usageWater: 28,
    usageElectricityLow: 1580,
    usageElectricityHigh: 1770,
    usageGas: 1380,
  },
  {
    residents: 4,
    buildingType: BuildingType.SemiDetachedHouse,
    buildingAge: BuildingAgeType.Between1945And2000,
    usageWarmth: 33,
    usageWater: 28,
    usageElectricityLow: 1620,
    usageElectricityHigh: 1570,
    usageGas: 1130,
  },
  {
    residents: 4,
    buildingType: BuildingType.SemiDetachedHouse,
    buildingAge: BuildingAgeType.After2000,
    usageWarmth: 33,
    usageWater: 28,
    usageElectricityLow: 1980,
    usageElectricityHigh: 1770,
    usageGas: 1030,
  },
  {
    residents: 4,
    buildingType: BuildingType.DetachedHouse,
    buildingAge: BuildingAgeType.Before1945,
    usageWarmth: 49,
    usageWater: 28,
    usageElectricityLow: 1940,
    usageElectricityHigh: 2140,
    usageGas: 1520,
  },
  {
    residents: 4,
    buildingType: BuildingType.DetachedHouse,
    buildingAge: BuildingAgeType.Between1945And2000,
    usageWarmth: 49,
    usageWater: 28,
    usageElectricityLow: 2150,
    usageElectricityHigh: 2030,
    usageGas: 1450,
  },
  {
    residents: 4,
    buildingType: BuildingType.DetachedHouse,
    buildingAge: BuildingAgeType.After2000,
    usageWarmth: 49,
    usageWater: 28,
    usageElectricityLow: 2480,
    usageElectricityHigh: 2210,
    usageGas: 1200,
  },
  {
    residents: 5,
    buildingType: BuildingType.Apartment,
    buildingAge: BuildingAgeType.Before1945,
    usageWarmth: 18,
    usageWater: 28,
    usageElectricityLow: 890,
    usageElectricityHigh: 1430,
    usageGas: 1180,
  },
  {
    residents: 5,
    buildingType: BuildingType.Apartment,
    buildingAge: BuildingAgeType.Between1945And2000,
    usageWarmth: 18,
    usageWater: 28,
    usageElectricityLow: 940,
    usageElectricityHigh: 1250,
    usageGas: 640,
  },
  {
    residents: 5,
    buildingType: BuildingType.Apartment,
    buildingAge: BuildingAgeType.After2000,
    usageWarmth: 18,
    usageWater: 28,
    usageElectricityLow: 1050,
    usageElectricityHigh: 1220,
    usageGas: 640,
  },
  {
    residents: 5,
    buildingType: BuildingType.CornerHouse,
    buildingAge: BuildingAgeType.Before1945,
    usageWarmth: 37,
    usageWater: 28,
    usageElectricityLow: 1380,
    usageElectricityHigh: 1700,
    usageGas: 1320,
  },
  {
    residents: 5,
    buildingType: BuildingType.CornerHouse,
    buildingAge: BuildingAgeType.Between1945And2000,
    usageWarmth: 37,
    usageWater: 28,
    usageElectricityLow: 1290,
    usageElectricityHigh: 1410,
    usageGas: 1000,
  },
  {
    residents: 5,
    buildingType: BuildingType.CornerHouse,
    buildingAge: BuildingAgeType.After2000,
    usageWarmth: 37,
    usageWater: 28,
    usageElectricityLow: 1580,
    usageElectricityHigh: 1580,
    usageGas: 890,
  },
  {
    residents: 5,
    buildingType: BuildingType.TerracedHouse,
    buildingAge: BuildingAgeType.Before1945,
    usageWarmth: 26,
    usageWater: 28,
    usageElectricityLow: 1240,
    usageElectricityHigh: 1610,
    usageGas: 1230,
  },
  {
    residents: 5,
    buildingType: BuildingType.TerracedHouse,
    buildingAge: BuildingAgeType.Between1945And2000,
    usageWarmth: 26,
    usageWater: 28,
    usageElectricityLow: 1270,
    usageElectricityHigh: 1410,
    usageGas: 940,
  },
  {
    residents: 5,
    buildingType: BuildingType.TerracedHouse,
    buildingAge: BuildingAgeType.After2000,
    usageWarmth: 26,
    usageWater: 28,
    usageElectricityLow: 1570,
    usageElectricityHigh: 1590,
    usageGas: 860,
  },
  {
    residents: 5,
    buildingType: BuildingType.SemiDetachedHouse,
    buildingAge: BuildingAgeType.Before1945,
    usageWarmth: 33,
    usageWater: 28,
    usageElectricityLow: 1660,
    usageElectricityHigh: 1900,
    usageGas: 1410,
  },
  {
    residents: 5,
    buildingType: BuildingType.SemiDetachedHouse,
    buildingAge: BuildingAgeType.Between1945And2000,
    usageWarmth: 33,
    usageWater: 28,
    usageElectricityLow: 1620,
    usageElectricityHigh: 1640,
    usageGas: 1160,
  },
  {
    residents: 5,
    buildingType: BuildingType.SemiDetachedHouse,
    buildingAge: BuildingAgeType.After2000,
    usageWarmth: 33,
    usageWater: 28,
    usageElectricityLow: 1980,
    usageElectricityHigh: 1820,
    usageGas: 1030,
  },
  {
    residents: 5,
    buildingType: BuildingType.DetachedHouse,
    buildingAge: BuildingAgeType.Before1945,
    usageWarmth: 49,
    usageWater: 28,
    usageElectricityLow: 1940,
    usageElectricityHigh: 2140,
    usageGas: 1560,
  },
  {
    residents: 5,
    buildingType: BuildingType.DetachedHouse,
    buildingAge: BuildingAgeType.Between1945And2000,
    usageWarmth: 49,
    usageWater: 28,
    usageElectricityLow: 2150,
    usageElectricityHigh: 2030,
    usageGas: 1480,
  },
  {
    residents: 5,
    buildingType: BuildingType.DetachedHouse,
    buildingAge: BuildingAgeType.After2000,
    usageWarmth: 49,
    usageWater: 28,
    usageElectricityLow: 2580,
    usageElectricityHigh: 2230,
    usageGas: 1200,
  },
];

export default usageEstimates;
